module.exports = __webpack_public_path__ + "img/Warrior-orc-m-1.4ef25235.gif";